import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useLang();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      if (!sessionId) { navigate("/app", { replace: true }); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        const dest = sessionStorage.getItem("decide_post_login") || "/app";
        sessionStorage.removeItem("decide_post_login");
        navigate(dest, { replace: true });
      } catch (e) {
        navigate("/app", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-decide-canvas">
      <Logo size="lg" />
      <p className="text-decide-slate text-sm animate-pulse">{t("auth.signingIn")}</p>
    </div>
  );
}
